import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Portafoglio } from 'src/app/models/portafoglio';
import { RenameModel } from 'src/app/models/renameModel';

@Component({
  selector: 'app-rename-portfolio',
  templateUrl: './rename.component.html',
  styleUrls: []
})
export class RenameComponent implements OnInit {

  toUpdate : RenameModel;
  constructor(public dialogRef: MatDialogRef<boolean>,
    @Inject(MAT_DIALOG_DATA) public toRename
    ) {
      this.toUpdate = toRename;
     }

  ngOnInit(): void {
  }

  onYesClick(name:string): void {
    this.toUpdate.name = name;
    this.dialogRef.close(this.toUpdate);
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

}
